import { connect } from 'react-redux';

import { getArticleList } from 'store/ArticleCatalog/selectors';

import { generateArticlesMarkup } from './utils';
import { SeoLayout } from '../layout';

const mapStateToProps = (state) => {
  const data = getArticleList(state);
  return {
    markup: generateArticlesMarkup(data),
  };
};

export default connect(mapStateToProps)(SeoLayout);
